<template>
  <b-form-group
    label="Tanggal Perolehan"
    label-for="tahunPerolehan"
    label-class="pb-0 pt-0"
  >
    <b-form-input
      v-model="tanggalPerolehan"
      disabled
    />
  </b-form-group>
</template>
<script>
export default {
  props: {
    tanggalPerolehan: { type: String, default: '' },
  },
}
</script>
